import React from 'react';


function valueOrNull(value) {
  return value && <div className="list__text__size">{value}</div>;
}


function Customer({ customer, onSelect }) {
  const primaryEmail = customer.emailAddresses.find(e => e.primary) || customer.emailAddresses[0];
  const primaryAddress = customer.addresses.find(a => a.type.toLowerCase() === 'billing') || customer.addresses[0];
  const primaryPhone = customer.phoneNumbers.find(a => a.primary) || customer.phoneNumbers[0];
  return (
    <li
      key={customer.guid}
      className="clickable-link u-padding-top-tiny u-padding-bottom-tiny"
      onClick={() => onSelect(customer)}
    >
      <span className="">{customer.title} {customer.firstName} {customer.surname}</span>
      {valueOrNull(primaryEmail && primaryEmail.address)}
      {valueOrNull(primaryAddress && primaryAddress.line1)}
      {valueOrNull(primaryAddress && primaryAddress.line2)}
      {valueOrNull(primaryAddress && primaryAddress.line3)}
      {valueOrNull(primaryAddress && primaryAddress.line4)}
      {valueOrNull(primaryAddress && primaryAddress.postCode)}
      {valueOrNull(primaryPhone && primaryPhone.number)}
    </li>
  );
}


function CustomerMultiSelect({ customers, onSelect, onClose }) {
  if (!customers) return null;

  customers = customers.filter(function(customer) {
    return (customer != null);
  });

  return (
    <ul
      className="u-padding-x-small  c-customer-multi-select  u-border-box"
    >

      {
        customers && customers.length ? (
          <div className="u-flex u-flex-justify-end">
            <span
              className="clickable-link  c-btn--link"
              onClick={() => onClose()}
            >
              close
        </span>
          </div>

        ) : null
      }

      {
        customers.map(customer => (
          <Customer
            key={customer.guid}
            customer={customer}
            onSelect={onSelect}
          />))
      }

    </ul>
  );
}

export default CustomerMultiSelect;



// WEBPACK FOOTER //
// ./src/pages/AdminPage/CustomerMultiSelect.js